/* eslint-disable eqeqeq */
import { Box, ButtonBase, SvgIcon, Typography } from "@mui/material";
import { useState } from "react";
import Switch from "react-ios-switch";
import AllFilters from "./all-filters";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { setInstantBooking } from "slices/searchListingReducer";

const AttachmentBlackIcon = require("assets/img/png/Attachment_black1.png");
const AttachmentWhiteIcon = require("assets/img/png/attachment_white_ic.png");

const OptionButton = ({
  label,
  icon,
  selected = false,
  onClick,
}: {
  label: String;
  icon: any;
  selected: Boolean;
  onClick: any;
}) => {
  return (
    <ButtonBase
      sx={{
        ...(selected
          ? {
              background: "#6E8C20",

              path: {
                fill: "#FFF",
              },
              rect: {
                fill: "#FFF",
              },
            }
          : {
              path: {
                fill: "#323232",
              },
            }),
        border: "1px solid #E2E2E2",
        borderRadius: "30px",
        px: "15px",
        py: "7px",
        display: "flex",
        gap: "10px",
      }}
      onClick={onClick}
    >
      {icon}
      <Typography
        sx={{
          lineHeight: "24px",
          fontSize: "15px",
          color: selected ? "#FFF" : "#323232",
          textWrap: "nowrap",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </ButtonBase>
  );
};

const ListFilters = () => {
  const dispatch = useAppDispatch();
  const { instantBooking } = useAppSelector(
    (state) => state.searchListingReducer
  );
  const [query] = useSearchParams();
  const existingParams = document.location.toString().split("?")[1];
  const queryRequirement = query.get("requirement");
  const [selectedFilters, setSelectedFilters] = useState({
    all: false,
    tractor: false,
    attachment: false,
    heavyEqp: false,
  });
  const navigate = useNavigate();

  const [showFilters, setShowFilters] = useState(false);
  const handleShowFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleInstantBookingChange = () =>
    dispatch(setInstantBooking(!instantBooking));

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          // px: "3%",
          py: "15px",
          display: "flex",
          gap: "15px",
          overflow: "auto",
          flexWrap: "nowrap",
          position: "relative",

          pr: {
            md: "3%",
            lg: "3%",
            xl: "3%",
            // sm: "300px",
            // xs: "300px",
          },
          pl: "3%",
        }}
      >
        <OptionButton
          label="All"
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.2924 3C14.3304 3 13.2954 4.0349 13.2954 5.99672V7.70656C13.2954 9.66838 14.3304 10.7033 16.2924 10.7033H18.0024C19.9644 10.7033 20.9994 9.66838 20.9994 7.70656V5.99672C20.9994 4.0349 19.9644 3 18.0024 3H16.2924Z"
                fill="#323232"
              />
              <path
                d="M6.00601 13.2858C4.035 13.2858 3 14.3207 3 16.2825V17.9923C3 19.9631 4.035 20.998 5.99701 20.998H7.70702C9.66903 20.998 10.704 19.9631 10.704 18.0013V16.2915C10.713 14.3207 9.67803 13.2858 7.71602 13.2858H6.00601Z"
                fill="#323232"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.86102 10.7213C4.72864 10.7213 3 8.99281 3 6.86064C3 4.72847 4.72864 3 6.86102 3C8.99339 3 10.722 4.72847 10.722 6.86064C10.722 8.99281 8.99339 10.7213 6.86102 10.7213Z"
                fill="#323232"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.1388 21C15.0065 21 13.2778 19.2715 13.2778 17.1393C13.2778 15.0072 15.0065 13.2787 17.1388 13.2787C19.2712 13.2787 20.9999 15.0072 20.9999 17.1393C20.9999 19.2715 19.2712 21 17.1388 21Z"
                fill="#323232"
              />
            </svg>
          }
          selected={!queryRequirement || queryRequirement === "0"}
          onClick={() => {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("requirement", "");
            searchParams.set("page", "1");
            navigate(`${ROUTES.SEARCH_LISTING}?${searchParams}`);
          }}
        />
        <OptionButton
          label="Tractor"
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.94285 15.9785C5.35056 15.9785 4.86865 16.4609 4.86865 17.0538C4.86865 17.6467 5.35052 18.1291 5.94285 18.1291C6.53514 18.1291 7.01701 17.6467 7.01701 17.0538C7.01701 16.4609 6.53514 15.9785 5.94285 15.9785Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.00146 17.0538C1.00146 14.3264 3.21805 12.1075 5.94263 12.1075C8.6672 12.1075 10.8838 14.3264 10.8837 17.0538C10.8837 19.7812 8.6672 22 5.94263 22C3.21805 22 1.00146 19.7812 1.00146 17.0538ZM3.57953 17.0538C3.57953 18.3582 4.63963 19.4194 5.94267 19.4194C7.24571 19.4194 8.30581 18.3582 8.30581 17.0538C8.30581 15.7494 7.24571 14.6882 5.94267 14.6882C4.63963 14.6882 3.57953 15.7494 3.57953 17.0538ZM19.0045 15.9784C17.3434 15.9784 15.9969 17.3264 15.9969 18.9892C15.9969 20.652 17.3434 22 19.0045 22C20.6656 22 22.0121 20.652 22.0121 18.9892C22.0121 17.3264 20.6656 15.9784 19.0045 15.9784ZM18.36 18.9892C18.36 19.3455 18.6486 19.6344 19.0045 19.6344C19.3604 19.6344 19.649 19.3455 19.649 18.9892C19.649 18.6328 19.3604 18.344 19.0045 18.344C18.6486 18.344 18.36 18.6328 18.36 18.9892Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.3555 10.4732H20.3364V8.06952C20.3364 7.95094 20.4328 7.85446 20.5513 7.85446H21.1098C21.4658 7.85446 21.7543 7.5656 21.7543 7.2093C21.7543 6.853 21.4658 6.56414 21.1098 6.56414H20.5513C19.7221 6.56414 19.0474 7.23945 19.0474 8.06952V10.4732H15.6532L13.832 3.29033H14.2925C14.6484 3.29033 14.937 3.00146 14.937 2.64516C14.937 2.28886 14.6484 2 14.2925 2H4.51042C4.15449 2 3.86593 2.28886 3.86593 2.64516C3.86593 3.00146 4.15449 3.29033 4.51042 3.29033H4.64744L3.90292 9.8112C2.93829 10.0844 2.02951 10.5494 1.2409 11.1835C0.963429 11.4066 0.91913 11.8127 1.14204 12.0905C1.36495 12.3683 1.77055 12.4126 2.04811 12.1895C3.16463 11.2917 4.51128 10.8172 5.94253 10.8172C9.37785 10.8172 12.1727 13.6149 12.1727 17.0538C12.1727 17.3719 12.1484 17.6915 12.1006 18.0035C12.0467 18.3557 12.2881 18.685 12.64 18.739C12.6726 18.744 12.7055 18.7465 12.7385 18.7465C13.0513 18.7465 13.3258 18.5181 13.3747 18.1991C13.4001 18.0338 13.4196 17.8667 13.4339 17.6989H14.9054C15.4541 15.9557 17.0841 14.688 19.0044 14.688C20.7728 14.688 22.2948 15.763 22.9532 17.2944C22.9841 17.218 23 17.1362 23 17.0538V11.1183C23 10.762 22.7115 10.4732 22.3555 10.4732ZM5.94257 9.52685C5.70368 9.52685 5.46552 9.53886 5.22877 9.56169L5.94476 3.29033H10.1963V10.4732H9.58886C8.50822 9.87073 7.26486 9.52685 5.94257 9.52685ZM11.4853 3.29033V10.4732H14.3233L12.5021 3.29033H11.4853Z"
                fill="white"
              />
            </svg>
          }
          selected={queryRequirement == "1"}
          onClick={() => {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("requirement", "1");
            searchParams.set("page", "1");
            navigate(`${ROUTES.SEARCH_LISTING}?${searchParams}`);
          }}
        />
        <OptionButton
          label="Attachment"
          icon={
            queryRequirement == "2" ? (
              <img src={AttachmentWhiteIcon} alt="" height="24" width="24" />
            ) : (
              <img src={AttachmentBlackIcon} alt="" height="24" width="24" />
            )
          }
          selected={queryRequirement == "2"}
          onClick={() => {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("requirement", "2");
            searchParams.set("page", "1");
            navigate(`${ROUTES.SEARCH_LISTING}?${searchParams}`);
          }}
        />
        {/* <OptionButton
          label="Heavy Equipment"
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4332 21.3678H2.5786C1.15688 21.3678 0 20.2114 0 18.7897C0 17.3675 1.15688 16.2111 2.5786 16.2111H14.4337C15.8554 16.2111 17.0118 17.3675 17.0118 18.7893C17.0118 20.2114 15.855 21.3678 14.4332 21.3678ZM2.95407 19.9574C2.31047 19.9574 1.78641 19.4333 1.78641 18.7893C1.78641 18.1457 2.31047 17.6216 2.95407 17.6216C3.59813 17.6216 4.12172 18.1457 4.12172 18.7893C4.12172 19.4333 3.59813 19.9574 2.95407 19.9574ZM2.95407 18.0903C2.56875 18.0903 2.25516 18.4039 2.25516 18.7893C2.25516 19.175 2.56875 19.4886 2.95407 19.4886C3.33985 19.4886 3.65344 19.175 3.65344 18.7893C3.65344 18.4039 3.33938 18.0903 2.95407 18.0903ZM6.65532 19.9574C6.01172 19.9574 5.48766 19.4333 5.48766 18.7893C5.48766 18.1457 6.01172 17.6216 6.65532 17.6216C7.29938 17.6216 7.82297 18.1457 7.82297 18.7893C7.82297 19.4333 7.29938 19.9574 6.65532 19.9574ZM6.65532 18.0903C6.27 18.0903 5.95641 18.4039 5.95641 18.7893C5.95641 19.175 6.27 19.4886 6.65532 19.4886C7.0411 19.4886 7.35469 19.175 7.35469 18.7893C7.35469 18.4039 7.0411 18.0903 6.65532 18.0903ZM10.3565 19.9574C9.71297 19.9574 9.18891 19.4333 9.18891 18.7893C9.18891 18.1457 9.71297 17.6216 10.3565 17.6216C11.0006 17.6216 11.5246 18.1457 11.5246 18.7893C11.5246 19.4333 11.0006 19.9574 10.3565 19.9574ZM10.3565 18.0903C9.97125 18.0903 9.65766 18.4039 9.65766 18.7893C9.65766 19.175 9.97125 19.4886 10.3565 19.4886C10.7423 19.4886 11.0559 19.175 11.0559 18.7893C11.0559 18.4039 10.7423 18.0903 10.3565 18.0903ZM14.0578 19.9574C13.4137 19.9574 12.8901 19.4333 12.8901 18.7893C12.8901 18.1457 13.4137 17.6216 14.0578 17.6216C14.7018 17.6216 15.2254 18.1457 15.2254 18.7893C15.2254 19.4333 14.7018 19.9574 14.0578 19.9574ZM14.0578 18.0903C13.6725 18.0903 13.3589 18.4039 13.3589 18.7893C13.3589 19.175 13.6725 19.4886 14.0578 19.4886C14.4435 19.4886 14.7571 19.175 14.7571 18.7893C14.7571 18.4039 14.4435 18.0903 14.0578 18.0903ZM18.7781 19.941H17.2546C17.4 19.5857 17.4806 19.1966 17.4806 18.7893C17.4806 18.3819 17.4004 17.9933 17.2546 17.6375H18.7781V19.941ZM23.7628 21.3894H20.6395C19.8717 21.3894 19.2468 20.7646 19.2468 19.9963V12.5296C19.2468 11.7613 19.8717 11.1364 20.6395 11.1364H22.5065C22.5829 11.1364 22.6546 11.1735 22.6982 11.2363C22.7423 11.2986 22.7531 11.3788 22.7268 11.4505C21.9712 13.5341 21.6909 15.5328 21.9164 17.2311C22.1348 18.8746 22.8164 20.1627 23.8879 20.9572C23.9535 20.9985 23.9971 21.0716 23.9971 21.155C23.9971 21.2844 23.8921 21.3894 23.7628 21.3894ZM17.7178 17.1693V15.313C17.7178 14.5907 18.1546 13.9686 18.7781 13.6968V17.1693H17.7178ZM3.18657 15.7424V15.276H13.8257V15.7424H3.18657ZM15.4739 14.8072H1.53797C1.1686 14.8072 0.868125 14.5068 0.868125 14.1374V10.9255C0.868125 10.5561 1.1686 10.2557 1.53797 10.2557H8.27157V7.60491C8.27157 7.23553 8.57204 6.93506 8.94141 6.93506H14.1675C14.3132 6.93506 14.654 6.93506 15.4382 8.63335C15.7804 9.37444 16.1437 10.3218 16.1437 10.6189V14.1374C16.1437 14.5068 15.8432 14.8072 15.4739 14.8072ZM14.4398 11.8672H11.2279C11.1646 11.8672 11.1037 11.8414 11.0596 11.796L9.75329 10.4488C9.7111 10.4052 9.68719 10.3466 9.68719 10.2857V8.50256C9.68719 8.37319 9.79219 8.26819 9.92157 8.26819H13.6368C13.7245 8.26819 13.8051 8.31741 13.8454 8.39569L14.6484 9.96083C14.6653 9.99413 14.6742 10.0307 14.6742 10.0677V11.6328C14.6742 11.7622 14.5692 11.8672 14.4398 11.8672ZM11.3273 11.3985H14.2054V10.1244L13.4934 8.73694H10.1559V10.1905L11.3273 11.3985ZM2.94 13.5547C2.90625 13.5547 2.8725 13.5477 2.84016 13.5327C2.8123 13.5196 2.7873 13.5011 2.76659 13.4783C2.74588 13.4555 2.72987 13.4288 2.71946 13.3998C2.70906 13.3708 2.70447 13.3401 2.70596 13.3093C2.70744 13.2785 2.71498 13.2484 2.72813 13.2205L3.59907 11.3699C3.65391 11.2527 3.7936 11.2025 3.91078 11.2574C3.96698 11.2839 4.01038 11.3315 4.03147 11.39C4.05256 11.4484 4.04961 11.5128 4.02328 11.5691L3.15188 13.4202C3.13298 13.4604 3.10301 13.4944 3.06549 13.5183C3.02797 13.5421 2.98445 13.5547 2.94 13.5547ZM4.38235 13.5547C4.34907 13.5547 4.31485 13.5477 4.28297 13.5327C4.22673 13.5061 4.1833 13.4584 4.16222 13.3998C4.14113 13.3413 4.1441 13.2768 4.17047 13.2205L5.04141 11.3699C5.06797 11.3136 5.11574 11.2702 5.17426 11.2491C5.23278 11.228 5.29727 11.231 5.3536 11.2574C5.47032 11.3127 5.52094 11.4524 5.46563 11.5691L4.59469 13.4202C4.57574 13.4605 4.5457 13.4945 4.50809 13.5184C4.47049 13.5422 4.42687 13.5548 4.38235 13.5547ZM5.82516 13.5547C5.79141 13.5547 5.75766 13.5477 5.72532 13.5327C5.69746 13.5196 5.67246 13.5011 5.65175 13.4783C5.63104 13.4555 5.61502 13.4288 5.60462 13.3998C5.59422 13.3708 5.58963 13.3401 5.59111 13.3093C5.5926 13.2785 5.60013 13.2484 5.61328 13.2205L6.48422 11.3699C6.51068 11.3137 6.55836 11.2702 6.61681 11.2491C6.67525 11.228 6.73968 11.231 6.79594 11.2574C6.85214 11.2839 6.89554 11.3315 6.91663 11.39C6.93771 11.4484 6.93477 11.5128 6.90844 11.5691L6.03704 13.4202C6.01813 13.4604 5.98817 13.4944 5.95065 13.5183C5.91313 13.5421 5.8696 13.5547 5.82516 13.5547ZM10.8876 12.7925H9.88079C9.81869 12.7925 9.75913 12.7679 9.71522 12.724C9.67131 12.68 9.64664 12.6205 9.64664 12.5584C9.64664 12.4963 9.67131 12.4367 9.71522 12.3928C9.75913 12.3489 9.81869 12.3243 9.88079 12.3243H10.8876C11.0175 12.3243 11.122 12.4288 11.122 12.5582C11.122 12.688 11.0175 12.7925 10.8876 12.7925Z"
                fill="#323232"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.00352 9.78682V4.12523L5.60149 3.7746C5.55078 3.76192 5.50576 3.73267 5.47357 3.69148C5.44138 3.65029 5.42388 3.59953 5.42383 3.54726V2.23429C5.42383 2.1607 5.45852 2.09132 5.51758 2.04679C5.54672 2.02502 5.58051 2.0103 5.6163 2.00379C5.65208 1.99728 5.68889 1.99917 5.72383 2.00929L8.17117 2.72132C8.66664 2.86523 8.74071 3.17507 8.74071 3.3471V6.48398C8.20821 6.57913 7.80321 7.04507 7.80321 7.60476V9.78682H7.00352Z"
                fill="#323232"
              />
            </svg>
          }
          selected={queryRequirement == "3"}
          onClick={() => {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("requirement", "3");
            searchParams.set("page", "1");
            navigate(`${ROUTES.SEARCH_LISTING}?${searchParams}`);
          }}
        /> */}
        <Box sx={{ flex: 1 }} />
        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "12px",
            px: "15px",
            py: "7px",
            display: "flex",
            gap: "10px",
            flexWrap: "nowrap",

            mr: { sm: "80px", xs: "80px", lg: "0", xl: "0", md: 0 },
          }}
        >
          <Typography
            sx={{
              lineHeight: "24px",
              fontSize: "15px",
              color: "#323232",
              textWrap: "nowrap",
              width: "170px",
            }}
          >
            Need Instant Booking?
          </Typography>
          <Box
            sx={{
              span: {
                height: "25px !important",
                width: "45px !important",
                background: "gray",
              },
              "span span": {
                height: "21px !important",
                width: "21px !important",
              },
            }}
            height="24px"
          >
            <Switch
              checked={instantBooking}
              onChange={handleInstantBookingChange}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: {
              md: "none",
              lg: "none",
              xl: "none",
              sm: "flex",
              xs: "flex",
            },
          }}
        >
          &nbsp;&nbsp;
        </Box>
      </Box>

      <Box
        sx={{
          display: {
            lg: "none",
            xl: "none",
            md: "none",
            sm: "flex",
            xs: "flex",
          },
          justifyContent: "flex-end",
          paddingRight: "10px",
          alignItems: "center",
          width: "110px",
          height: "72px",
          background:
            "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 42%)",
          position: "absolute",
          right: 0,
          top: 0,
        }}
      >
        <ButtonBase
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40px",
            width: "40px",
            border: "1px solid #E2E2E2",
            borderRadius: "5px",
          }}
          onClick={handleShowFilters}
        >
          <img
            src="/assets/img/icons/setting_search.svg"
            alt=""
            width="24"
            height="24"
          />
        </ButtonBase>
      </Box>

      {showFilters && <AllFilters onClose={handleShowFilters} />}
    </Box>
  );
};

export default ListFilters;
